import { tokenize, type TokenType } from "../tokenize";
import { dark } from "../theme";
import { type LayoutFn, type Theme } from "./base";
import { box, lines, type BoxAction } from "./layout";

export function tokenColor(type: TokenType, theme: Theme): string {
  switch (type) {
    case "keyword": return theme.syntax.keyword;
    case "string": return theme.syntax.string;
    case "number": return theme.syntax.number;
    case "comment": return theme.syntax.comment;
    case "punctuation": return theme.syntax.punctuation;
    case "function": return theme.syntax.function;
    case "type": return theme.syntax.type;
    default: return theme.syntax.default;
  }
}

export function code(
  source: string,
  opts?: { language?: string; title?: string; borderColor?: string; theme?: Theme; copyable?: boolean; action?: BoxAction },
): LayoutFn {
  const t = opts?.theme ?? dark;
  const tokens = tokenize(source, opts?.language);
  const copyAction = opts?.copyable !== false
    ? { label: "cp", onClick: () => navigator.clipboard.writeText(source), color: t.semantic.frameMuted }
    : undefined;
  return box(
    lines(
      tokens.length > 0
        ? tokens.map((lineTokens) =>
            lineTokens.length === 0
              ? [{ text: " ", color: t.markdown.codeEmpty }]
              : lineTokens.map((tok) => ({ text: tok.text, color: tokenColor(tok.type, t) })),
          )
        : [[{ text: " ", color: t.markdown.codeEmpty, dim: true }]],
    ),
    {
      title: opts?.title ?? (opts?.language ? `code:${opts.language}` : "code"),
      borderColor: opts?.borderColor ?? t.markdown.codeBorder,
      action: opts?.action ?? copyAction,
    },
  );
}
